import React, { Component} from 'react';
import uuid from 'uuid';

const TodoContext = React.createContext();

class TodoProvider extends Component {

  // data store
  state = {
    items:[],
    title: '',
    editItem: false
  }

  handleChange = e => {
    this.setState({
      title: e.target.value
    })
  }

  handleSubmit = e => {
    e.preventDefault();

    if(this.state.title === '') {
      alert('Title is required')
    }
    else {
      // new item
      const newItem = {
        id: uuid(),
        title: this.state.title
      }

      // updated Items
      const updatedItems = [newItem,...this.state.items];

      // clear state
      this.setState({
        items: updatedItems,
        title: '',
        id: uuid(),
        editItem: false
      })
    }
    
  }

  clearList = () => {
    this.setState({
      items:[]
    })
  }

  handleDelete = (id) => {
    const filteredItems = this.state.items.filter(item => item.id !== id);

    this.setState({
      items: filteredItems
    })
  }

  handleEdit = (id) => {
    const filteredItems = this.state.items.filter(item => item.id !== id);

    const selectedItem = this.state.items.find(item => item.id === id);

    this.setState({
      items: filteredItems,
      title:selectedItem.title,
      id:id,
      editItem: true
    })
  }

  // dom rendder
  render() {
    return(
      <TodoContext.Provider value={{
        ...this.state,
        handleChange: this.handleChange,
        handleSubmit: this.handleSubmit,
        clearList: this.clearList,
        handleDelete: this.handleDelete,
        handleEdit: this.handleEdit 
      }}>
        {this.props.children}
      </TodoContext.Provider>
    )
  }

}
const TodoConsumer = TodoContext.Consumer;

export {TodoProvider,TodoConsumer,TodoContext}